import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function fotoPerfilReducer(state= initialState.fotoPerfil, action){
	
	switch(action.type){
		case types.SET_FOTO_PERFIL_SUCCESS:
            
			return action.datos;
		//break;		
	
		default:
			return state;
	}
}